exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crearMovimiento #alinear[data-v-42ac4a20] {\n  text-align: justify;\n}\n.crearMovimiento .h2_title[data-v-42ac4a20] {\n  font-weight: normal;\n}\n", ""]);

// exports
